// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"3c841a4d","401":"3c841a4d","464":"12d90d87"}[chunkId] + ".chunk.css";
};